<template>
    <div class="container">
        <h1 v-if="!model">Documentations</h1>

        <loading v-if="loading && !model" />

        <div v-if="!loading && model">
            <h1>{{ model.name }} Documentations</h1>

            <documentation-list :part-number-id="model.partNumberId" type-name="model.name" />
        </div>

        <div :class="['alert', 'mt-4', error.type ]" v-if="error">
            <h4 v-if="error.title">{{ error.title }}</h4>
            {{ error.text }}
        </div>
    </div>
</template>

<script>
    import DocumentationList from './documentation-list' 

    export default {
        props: {
            partNumberId: String,
        },

        components: {
            'documentation-list': DocumentationList,
        },

        data() {
            return {
                loading: false,
                error: null,
                model: null,
            }
        },

        methods: {
            rowClass(item) {
                return null;
            },
            async loadModel() {
                try {
                    this.loading = true;
                    this.error = null;

                    var response = await this.$http.get(`/part-number/${this.partNumberId}`);
                    if (response && response.data) this.model = response.data;
                    else throw new Error('Response is missing or does not contain any data');
                } catch (error) {
                    var text = '';
                    if (error && error.response && error.response.status === 500 && error.response.data && error.response.data.error) text = 'Error: ' + error.response.data.error;
                    else if (error && error.message) text = 'Message: ' + error.message;
                    if (text) this.$notify(this.error = { title: 'Error getting documentation type information', text: text, type: 'alert-danger', alertClasses: 'alert alert-danger', textClasses: 'text-danger' });
                } finally {
                    this.loading = false;
                }
            }
        },

        computed: {
        },

        watch: {
            async partNumberId() {
                await this.loadModel();
            },
        },

        async mounted() {
            await this.loadModel();
        },
    }
</script>

<style>
</style>